<template>
  <div>
    <div id="mapHere"></div>
  </div>
</template>

<script>
/* global CONFIG */
// import moment from 'moment-timezone'
import mapPins from '@/values/map-pin'
// import allAirports from '@/values/airports'

export default {
  name: 'fmap',
  data () {
    return {
      hereMaps: {
        map: {},
        platform: {},
        router: {},
        geocoder: {},
        directions: [],
        ui: {}
      },
      center: { lat: 33.942791, lng: -118.410042 }, // LAX coords
      routesQueue: []
    }
  },
  computed: {
    id () { return this.$route.params.id },
    flight () { return this.$store.state.flightDetails },
    details () { return this.flight.details },
    rsvp1 () { return this.flight.rsvp1 },
    rsvp2 () { return this.flight.rsvp2 },
    airports () { return this.$store.state.airports.list }
  },
  methods: {
    initMap () {
      let self = this
      let mapContainer = document.getElementById('mapHere')
      self.hereMaps.platform = new window.H.service.Platform({
        apikey: CONFIG.hereApi.key
      })

      let defaultLayers = self.hereMaps.platform.createDefaultLayers()
      self.hereMaps.map = new window.H.Map(mapContainer,
        defaultLayers.vector.normal.map, {
          center: self.center,
          zoom: 3,
          pixelRatio: window.devicePixelRatio || 1
        }
      )

      /* eslint-disable no-unused-vars */
      let behavior = new window.H.mapevents.Behavior(new window.H.mapevents.MapEvents(self.hereMaps.map))
      /* eslint-enable no-unused-vars */
      self.hereMaps.ui = window.H.ui.UI.createDefault(self.hereMaps.map, defaultLayers)
      window.addEventListener('resize', () => self.hereMaps.map.getViewPort().resize())
    },
    initPoints () {
      let self = this
      for (let object of self.hereMaps.map.getObjects()) {
        // if (object.id === 'pickup-pin') { self.hereMaps.map.removeObject(object) }
        self.hereMaps.map.removeObject(object)
      }

      let marker = '<svg height="25" width="25" style="overflow: unset" viewBox="0 0 50 50">' +
        '<path d="{D}" fill="{FILL}"stroke="{STROKE}"' +
        'stroke-width="{STROKE_WIDTH}" /></svg>'
      
      if (self.hasRsvp(self.rsvp1)) {
        let pickupMarker = marker.replace('{D}', mapPins.pickup.path)
          .replace('{FILL}', mapPins.pickup.fillColor)
          .replace('{STROKE}', mapPins.pickup.strokeColor)
          .replace('{STROKE_WIDTH}', mapPins.pickup.strokeWeight)
        let pickupIcon = new window.H.map.DomIcon(pickupMarker)
        let pickupCoords = {lat: self.rsvp1.pickup.lat, lng: self.rsvp1.pickup.lng}
        let pickupPin = new window.H.map.DomMarker(
          pickupCoords,
          {icon: pickupIcon}
        )
        pickupPin.id = 'pickup-pin'
        self.hereMaps.map.addObject(pickupPin)
      }

      self.details.flights.oneway.forEach((flight, i) => {
        let marker = '<svg height="25" width="25" style="overflow: unset" viewBox="0 0 50 50">' +
          '<path d="{D}" fill="{FILL}"stroke="{STROKE}"' +
          'stroke-width="{STROKE_WIDTH}" /></svg>'
        let pickupMarker = marker.replace('{D}', mapPins.pickup.path)
          .replace('{FILL}', '#3898ca')
          .replace('{STROKE}', mapPins.pickup.strokeColor)
          .replace('{STROKE_WIDTH}', mapPins.pickup.strokeWeight)
        let pickupIcon = new window.H.map.DomIcon(pickupMarker)

        let index = self.airports.findIndex(x => x.airportCode === flight.origin.code)
        if (index > -1) {
          let loc = self.airports[index]
          let pickupCoords = {lat: loc.lat, lng: loc.lng}
          let pickupPin = new window.H.map.DomMarker(
            pickupCoords,
            {icon: pickupIcon}
          )
          pickupPin.id = 'pickup-pin'
          self.hereMaps.map.addObject(pickupPin)
        }
        // let index2 = allAirports.findIndex(x => x.iata_code === flight.origin.code)
        // if (index === -1 && index2 > -1) {
        //   let loc = allAirports[index2]
        //   let pickupCoords = {lat: loc._geoloc.lat, lng: loc._geoloc.lng}
        //   let pickupPin = new window.H.map.DomMarker(
        //     pickupCoords,
        //     {icon: pickupIcon}
        //   )
        //   pickupPin.id = 'pickup-pin'
        //   self.hereMaps.map.addObject(pickupPin)
        // }

        if (i === self.details.flights.oneway.length - 1) {
          let index3 = self.airports.findIndex(x => x.airportCode === flight.destination.code)
          if (index3 > -1) {
            let loc = self.airports[index3]
            let pickupIcon = new window.H.map.DomIcon(pickupMarker)
            let pickupCoords = {lat: loc.lat, lng: loc.lng}
            let pickupPin = new window.H.map.DomMarker(
              pickupCoords,
              {icon: pickupIcon}
            )
            pickupPin.id = 'pickup-pin'
            self.hereMaps.map.addObject(pickupPin)
          }
          // let index4 = allAirports.findIndex(x => x.iata_code === flight.destination.code)
          // if (index3 === -1 && index4 > -1) {
          //   let loc = allAirports[index4]
          //   let pickupCoords = {lat: loc._geoloc.lat, lng: loc._geoloc.lng}
          //   let pickupPin = new window.H.map.DomMarker(
          //     pickupCoords,
          //     {icon: pickupIcon}
          //   )
          //   pickupPin.id = 'pickup-pin'
          //   self.hereMaps.map.addObject(pickupPin)
          // }
        }
      })

      if (self.hasRsvp(self.rsvp2)) {
        let dropoffMarker = marker.replace('{D}', mapPins.pickup.path)
          .replace('{FILL}', mapPins.dropoff.fillColor)
          .replace('{STROKE}', mapPins.dropoff.strokeColor)
          .replace('{STROKE_WIDTH}', mapPins.dropoff.strokeWeight)
        let dropoffIcon = new window.H.map.DomIcon(dropoffMarker)
        let dropoffCoords = {lat: self.rsvp2.dropoff.lat, lng: self.rsvp2.dropoff.lng}
        let dropoffPin = new window.H.map.DomMarker(
          dropoffCoords,
          {icon: dropoffIcon}
        )
        // dropoffPin.id = 'pickup-pin'
        self.hereMaps.map.addObject(dropoffPin)
      }

      self.routesQueue = []
      let pickupAirport = {}
      let index = self.airports.findIndex(x => x.airportCode === self.details.flights.oneway[0].origin.code)
      if (index > -1) pickupAirport = self.airports[index]
      if (self.hasRsvp(self.rsvp1)) {
        self.routesQueue.push({
          origin: {
            lat: self.rsvp1.pickup.lat,
            lng: self.rsvp1.pickup.lng,
          },
          destination: {
            lat: pickupAirport.lat,
            lng: pickupAirport.lng
          },
          mode: 'car'
        })
      }

      self.details.flights.oneway.forEach(flight => {
        let origin = {}
        let hasError = false
        let oIndex = self.airports.findIndex(x => x.airportCode === flight.origin.code)
        if (oIndex > -1) origin = self.airports[oIndex]
        else {
          // let i = allAirports.findIndex(x => x.iata_code === flight.origin.code)
          // if (oIndex === -1 && i > -1) {
          //   let loc = allAirports[i]
          //   origin = loc._geoloc
          // } else{
            hasError = true
          // }
        }

        let destination = {}
        let dIndex = self.airports.findIndex(x => x.airportCode === flight.destination.code)
        if (dIndex > -1) destination = self.airports[dIndex]
        else {
          // let i = allAirports.findIndex(x => x.iata_code === flight.destination.code)
          // if (dIndex === -1 && i > -1) {
          //   let loc = allAirports[i]
          //   destination = loc._geoloc
          // } else{
            hasError = true
          // }
        }

        if (!hasError) {
          self.routesQueue.push({
            origin: {
              lat: origin.lat,
              lng: origin.lng
            },
            destination: {
              lat: destination.lat,
              lng: destination.lng
            },
            mode: 'flight'
          })
        }
      })

      let dropoffAirport = {}
      let index2 = self.airports.findIndex(x => x.airportCode === self.details.flights.oneway[self.details.flights.oneway.length - 1].destination.code)
      if (index2 > -1) dropoffAirport = self.airports[index2]
      if (self.hasRsvp(self.rsvp2)) {
        self.routesQueue.push({
          origin: {
            lat: dropoffAirport.lat,
            lng: dropoffAirport.lng,
          },
          destination: {
            lat: self.rsvp2.dropoff.lat,
            lng: self.rsvp2.dropoff.lng,
          },
          mode: 'car'
        })
      }

      self.setRoute()
    },
    setRoute () {
      if (!this.routesQueue.length) {
        this.centerMap()
        return
      }

      let data = this.routesQueue[0]
      if (data.mode === 'car') this.setCarRoute(data)
      else this.setFlightRoute(data)
    },
    setCarRoute (data) {
      let router = this.hereMaps.platform.getRoutingService(null, 8)
      let routeRequestParams = {
        routingMode: 'fast',
        transportMode: 'car',
        origin: `${data.origin.lat},${data.origin.lng}`,
        destination: `${data.destination.lat},${data.destination.lng}`,
        return: 'polyline,turnByTurnActions,actions,instructions,travelSummary'
      }
      router.calculateRoute(
        routeRequestParams,
        this.onCalculateSuccess,
        this.onCalculateError
      )
    },
    onCalculateSuccess (result) {
      var route = result.routes[0].sections[0]

      let strokeColor = '#333333'
      let linestring = window.H.geo.LineString.fromFlexiblePolyline(route.polyline);
      let polyline = new window.H.map.Polyline(linestring, {
        style: {
          lineWidth: 3,
          strokeColor: strokeColor
        }
      })
      // polyline.id = extraData.type

      this.hereMaps.map.addObject(polyline)
      this.hereMaps.map.getViewModel().setLookAtData({
        bounds: polyline.getBoundingBox()
      })

      this.routesQueue.shift()
      this.setRoute()
    },
    onCalculateError (data) {
      console.error('ROUTING ERROR--', data)
    },
    setFlightRoute (data) {
      var lineString = new window.H.geo.LineString()
      lineString.pushPoint({lat: data.origin.lat, lng: data.origin.lng})
      lineString.pushPoint({lat: data.destination.lat, lng: data.destination.lng})
      let polyline = new window.H.map.Polyline(lineString,{
        style: {lineWidth: 4}
      })
      this.hereMaps.map.addObject(polyline)
      this.hereMaps.map.getViewModel().setLookAtData({
        bounds: polyline.getBoundingBox()
      })

      this.routesQueue.shift()
      this.setRoute()
    },
    centerMap () {
      let self = this
      let group = new window.H.map.Group()

      // Create object with radius for better bounds
      let groupObject = []
      if (self.hasRsvp(self.rsvp1)) {
        groupObject.push(new window.H.map.Circle(
          new window.H.geo.Point(self.rsvp1.pickup.lat, self.rsvp1.pickup.lng),
          7000,
          {
            style: {
              fillColor: 'rgba(0, 0, 0, 0)',
              strokeColor: 'rgba(0, 0, 0, 0)'
            }
          }
        ))
      } else {
        let airport = {}
        let index = self.airports.findIndex(x => x.airportCode === self.details.flights.oneway[0].origin.code)
        if (index > -1) {
          airport = self.airports[index]
          groupObject.push(new window.H.map.Circle(
            new window.H.geo.Point(airport.lat, airport.lng),
            7000,
            {
              style: {
                fillColor: 'rgba(0, 0, 0, 0)',
                strokeColor: 'rgba(0, 0, 0, 0)'
              }
            }
          ))
        }
      }

      if (self.hasRsvp(self.rsvp2)) {
        groupObject.push(new window.H.map.Circle(
          new window.H.geo.Point(self.rsvp2.dropoff.lat, self.rsvp2.dropoff.lng),
          7000,
          {
            style: {
              fillColor: 'rgba(0, 0, 0, 0)',
              strokeColor: 'rgba(0, 0, 0, 0)'
            }
          }
        ))
      } else {
        let airport = {}
        let index = self.airports.findIndex(x => x.airportCode === self.details.flights.oneway[self.details.flights.oneway.length - 1].destination.code)
        if (index > -1) {
          airport = self.airports[index]
          groupObject.push(new window.H.map.Circle(
            new window.H.geo.Point(airport.lat, airport.lng),
            7000,
            {
              style: {
                fillColor: 'rgba(0, 0, 0, 0)',
                strokeColor: 'rgba(0, 0, 0, 0)'
              }
            }
          ))
        }
      }

      // if (!self.hasRsvp(self.rsvp1) && !self.hasRsvp(self.rsvp2)) {
      //   groupObject.push(new window.H.map.Circle(
      //     new window.H.geo.Point(self.rsvp1.pickup.lat, self.rsvp1.pickup.lng),
      //     7000,
      //     {
      //       style: {
      //         fillColor: 'rgba(0, 0, 0, 0)',
      //         strokeColor: 'rgba(0, 0, 0, 0)'
      //       }
      //     }
      //   ))
      // }

      // Add to group for bounds correction
      if (groupObject.length) {
        group.addObjects(groupObject)
        group.id = 'groupBound'
        self.hereMaps.map.addObject(group)

        self.hereMaps.map.getViewModel().setLookAtData({
          bounds: group.getBoundingBox()
        })
      }
    },
    hasRsvp (x) {
      return Object.keys(x).length
    }
  },
  mounted () {
    this.initMap()
  }
}
</script>

<style lang="scss" scoped>
#mapHere{
  width: 100%;
  height: 400px;
  margin-bottom: 20px;
  box-shadow: 1px 1px 2px rgba(0,0,0, .3);
  border-radius: 4px;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/FlightDetails/fmap.vue